/**
 * SKŁADNIA createAsyncThunk:
 * https://redux-toolkit.js.org/api/createAsyncThunk
 */


import { createAsyncThunk } from '@reduxjs/toolkit'
import { SLICE_KEYS } from '../../SliceKeys'
import textContentsService from 'service/TextContentsService/TextContentsService'

export const setTextContentsThunkAction = createAsyncThunk(
   `${SLICE_KEYS.TEXT_CONTENTS_SLICE}/setTextContentsThunkAction`,
   async(_, { rejectWithValue }) => {
      try {
         const textContents = (await textContentsService.getTextContents()).data
         return textContents
      } 
      catch (error: any) {
         try { //Gdy za pierwszym razem nie uda się pobrać konfiguracji, dla pewności próbujemy raz jeszcze.
            const textContents = (await textContentsService.getTextContents()).data
            return textContents
         } 
         catch (error: any) {
            return rejectWithValue({})
         }
      }  
   }
)